import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getBrandList } from "../../services/super-admin.service";
import { getoffer } from "../../services/campaign.service";
import { selectCurrentUser } from "../../store/user/user.selector";
import toast from "react-hot-toast";
import AddIcon from "../../assets/images/add_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import EditIcon from "../../assets/images/edit_icon.svg";
import { getDocumentlist } from "../../services/Document.service";
import CreateDocumentType from "./Create-Document-Type";
import EditCategorysetting from "./Edit-Document-Type";
import ViewDocumentType from "./View-Document-Type";
import PaginatedTable from "../common/PaginatedTable";
// import EditCategorysetting from "./Edit-Category-setting";
// import ViewCategorysetting from "./View-Category-setting";
import { useTranslation } from 'react-i18next';  // Import useTranslation

const fileType = "Voucher";
function Document() {
  const [showCreate, setShowCreate] = useState(false);
  const { t, i18n } = useTranslation(); // Translation hook

  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [CategoryTable, setCategoryTable] = useState(true);
  const [data, setdata] = useState();
  const [Category, setCategory] = useState(null);
  const [status, setStatus] = useState("");

  const [brand, setBrand] = useState([]);
  const user = useSelector(selectCurrentUser)?.userDetail;
  const id = user?.userType === "brand" ? user?.brand_id : "";

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

  const handleShowCreate = () => {
    setShowCreate(true);
    setCategoryTable(false);
  };

  const handleShowedit = (data) => {
    setdata(data);
    setShowEdit(true);
    setCategoryTable(false);
  };

  const getAllcategory = async () => {
    const offset = (currentPage - 1) * itemsPerPage;
    const offsetToUse = offset >= 0 ? offset : 0;
    try {
      const requestBody = {
        offset: offsetToUse,
        limit: itemsPerPage,
        search: searchKey,
        statusfilter: status || "all",
      };
      const resp = await getDocumentlist(requestBody);

      if (resp?.status === 200 && resp?.data?.statusCode === 200) {
        setCategory(resp?.data?.data);
        setTotalCount(resp?.data?.count);
      } else {
        toast.error(resp?.message || resp?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        console.error(msg);
      }
      console.log(error.message);
    }
  };

  const [column, setColumn] = useState([
    {
      heading: () => t("common.Action"),
      cell: (row) => (
        <>
          <div>
            <button className="emptyBtn" onClick={() => handleShowView(row)}>
              <img src={ViewIcon} alt="ViewIcon" />
            </button>
          </div>
        </>
      ),
      hidden: false,
      // width: "50",
      // align: "center",
      id: 7,
    },
    {
      heading: () => t("document.DocumentType"),
      cell: (row) => (row["type"] ? row["type"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },
    {
      heading: () => t("document.UserType"),
      cell: (row) => (row["user_type"] ? row["user_type"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },

    {
      heading: () => t("common.Status"),
      cell: (row) => {
        console.log("row::: ", row);
        const status = row["active_flag"];
        console.log("status::: ", status);
        let displayText = "";
        let style = {};
        let className = "";

        if (status === true) {
          displayText = "Active";
        } else if (status === false) {
          displayText = "InActive";
          className = "fontWeight600 errorClr_text"; // Use class names directly
        } else if (status === "all") {
          displayText = "ALL Status";
          style = { color: "#28a745", fontWeight: 600 };
        } else {
          displayText = "-";
          style = { fontWeight: 600 };
        }

        return (
          <span
            className={
              row?.active_flag
                ? "fontWeight600 UFOGreen_text"
                : "fontWeight600 errorClr_text"
            }
            style={style}
          >
            {displayText}
          </span>
        );
      },
      hidden: false,
      width: "120",
      align: "left",
      id: 8,
    },
  ]);

  useEffect(() => {
    getAllcategory();
  }, [currentPage, itemsPerPage, searchKey, setSearchKey,status]);

  const handleShowView = (category) => {
    setCategoryTable(false);
    setdata(category);
    setShowView(true);
  };

  const back = (cond = true) => {
    cond && getAllcategory();
    setShowCreate(false);
    setShowEdit(false);
    setShowView(false);
    setCategoryTable(true);
  };

  return (
    <div>
      {CategoryTable && (
        <>
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                Document List
              </h5>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleShowCreate}
              >
                <img src={AddIcon} alt="AddIcon" className="width20px" />
                <span> Create Merchant document </span>
              </button>
            </div>
          </div>

          {isLoading ? (
            <PaginatedTable
              row={Category}
              column={column}
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isSearch={true}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              maxPageNumberLimit={maxPageNumberLimit}
              setMaxPageNumberLimit={setMaxPageNumberLimit}
              minPageNumberLimit={minPageNumberLimit}
              setMinPageNumberLimit={setMinPageNumberLimit}
              //  setRange={setRange}
              //  range={range}
              isExport={false}
              isDateRange={false}
              status={status}
              setStatus={setStatus}
              isstatus={true}
            />
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </>
      )}

      {showCreate && <CreateDocumentType brand={data} back={back} />}

      {showView && (
        <ViewDocumentType
          data={data}
          back={back}
          handleShowedit={handleShowedit}
        />
      )}
    </div>
  );
}

export default Document;
